<template>
  <v-container class="mt-5">
    <FollowupsTableFilter :user="user"/>
    <FollowupsTable :followups="filtered_followups" :user="user" />
  </v-container>
</template>

<script>
import FollowupsTable from "@/components/table/FollowupsTable.vue";
import FollowupsTableFilter from "@/components/filters/FollowupsTableFilters.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FollowUps",
  components: {
    FollowupsTable,
    FollowupsTableFilter,
  },
  methods: {
    ...mapActions({
      loadUserFollowups: "followups/loadUserFollowups",
      loadFilterParams: "followups/loadFilterParams",
    }),
  },
  mounted() {
    this.loadUserFollowups(this.user.id);
    this.loadFilterParams(this.user.id);
    this.sockets.subscribe("FOLLOWUP_UPDATE", () => {});
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      filtered_followups: "followups/filtered_followups",
      user_followups: "followups/user_followups",
      filter_params: "followups/filter_params",
    }),
    agentIcon() {
      if (this.filter_params.agent.length === this.agents.length)
        return "mdi-close-box";
      if (
        this.filter_params.agent.length < this.agents.length &&
        this.filter_params.agent.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
};
</script>

<style>
</style>